import { css } from '@emotion/react';

import * as React from 'react';

import { Grid, Skeleton, Typography, Typography2, VisuallyHidden } from '@coursera/cds-core';

import CatastrophicErrorNotification from 'bundles/admin-shared/components/CatastrophicErrorNotification';

import _t from 'i18n!nls/staff-management';

import { useAdminUserProfilesData } from './StaffPermissionsData/AdminUserProfilesData';
import UserCard from './UserCard';

const styles = {
  root: () => css`
    margin-bottom: var(--cds-spacing-600);
  `,
  infoContainer: () => css`
    margin-left: var(--cds-spacing-100);
  `,
};

const UserCardContainer = () => {
  const { email, fullName, profilePicture, timezoneName, adminUserProfilesGql } = useAdminUserProfilesData();

  if (!adminUserProfilesGql) {
    return null;
  }

  const { loading, error, data } = adminUserProfilesGql;

  if (loading && !data?.AdminUserProfiles?.queryByUser?.fullName) {
    return (
      <>
        <VisuallyHidden role="status" aria-live="polite" component="span" className="rc-A11yScreenReaderOnly">
          {_t('Loading user profile')}
        </VisuallyHidden>
        <Grid container alignItems="center" css={styles.root}>
          <Skeleton variant="circle" height={51} width={51} />
          <Grid item css={styles.infoContainer}>
            <Typography variant="h1semibold">
              <Skeleton width={200} />
            </Typography>
            <Typography2 component="p" variant="bodyPrimary">
              <Skeleton width={300} />
            </Typography2>
          </Grid>
        </Grid>
      </>
    );
  }

  if (error) {
    return (
      <CatastrophicErrorNotification
        message={_t('Could not fetch user profile. Please refresh the page and try again.')}
      />
    );
  }

  return <UserCard email={email} fullName={fullName} profilePicture={profilePicture} timezoneName={timezoneName} />;
};

export default UserCardContainer;
